import { NimbusAdminRoutes } from '@nimbus-admin/routing/nimbus-admin.routes';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

export const Routes = {
  Home: { name: TranslationKeys.MenuOverview, path: `/${NimbusAdminRoutes.Overview}` },
  Partners: { name: TranslationKeys.MenuPartners, path: `/${NimbusAdminRoutes.Partners}` },
  Tenants: { name: TranslationKeys.MenuTenants, path: `/${NimbusAdminRoutes.Tenants}` },
  Teams: { name: TranslationKeys.MenuTeams, path: `/${NimbusAdminRoutes.Teams.root}` },
  Users: { name: TranslationKeys.MenuUsers, path: `/${NimbusAdminRoutes.Users}` },
  Workflow: { name: TranslationKeys.MenuWorkflow, path: `/${NimbusAdminRoutes.Workflow}` },
  Reporting: { name: TranslationKeys.MenuReporting, path: `/${NimbusAdminRoutes.TeamReporting}` },
  Settings: { name: TranslationKeys.MenuSettings, path: `/${NimbusAdminRoutes.Settings}` },
  TenantSettings: { name: TranslationKeys.MenuTenant, path: `/${NimbusAdminRoutes.Tenant}` },
  Customer: { name: TranslationKeys.MenuCustomer, path: `/${NimbusAdminRoutes.Operations.root}/${NimbusAdminRoutes.Operations.customer}` },
  Service: { name: TranslationKeys.MenuService, path: `/${NimbusAdminRoutes.Operations.root}/${NimbusAdminRoutes.Operations.service}` },
  ChangeHistory: {
    name: TranslationKeys.MenuChangeHistory,
    path: `/${NimbusAdminRoutes.Operations.root}/${NimbusAdminRoutes.Operations.changeHistory}`,
  },
  FeatureFlagVisibility: {
    name: TranslationKeys.MenuFeatureFlagVisibility,
    path: `/${NimbusAdminRoutes.Operations.root}/${NimbusAdminRoutes.Operations.featureFlagVisibility}`,
  },
  TaskManagement: {
    name: TranslationKeys.MenuTaskManagement,
    path: `/${NimbusAdminRoutes.Operations.root}/${NimbusAdminRoutes.Operations.taskManagement}`,
  },
  ExternalTools: { name: TranslationKeys.MenuExternalTools, path: `/${NimbusAdminRoutes.ExternalTools}` },
  OperationsManage: { name: TranslationKeys.MenuManage, path: `/${NimbusAdminRoutes.OperationsManage}` },
  Tools: { name: TranslationKeys.MenuTools, path: `/${NimbusAdminRoutes.Tools}` },
  Authentication: { name: TranslationKeys.MenuAuthentication, path: `/${NimbusAdminRoutes.Authentication}` },
  TeamManage: { name: TranslationKeys.ManageTitle, path: `/${NimbusAdminRoutes.TeamManage.root}` },
  Licensing: { name: TranslationKeys.AdminLicensingPageTitle, path: `/${NimbusAdminRoutes.Licensing}` },
  CompanionConversation: { name: TranslationKeys.CompanionChatPageTitle, path: `/${NimbusAdminRoutes.CompanionConversation}` },
  UserPreferences: { name: TranslationKeys.UserPreferencesTitle, path: `/${NimbusAdminRoutes.UserPreferences}` },
  Brand: { name: 'Luware Ltd.' },
};
